import React from 'react';
import style from '../styles/kebijakanprivasiPageStyle.module.css';
import youtube from '../assets/images/Icons/icon-sosmed/youtube-icon.svg';
import instagram from '../assets/images/Icons/icon-sosmed/instagram-icon.svg';
import facebook from '../assets/images/Icons/icon-sosmed/facebook-icon.svg';
import tiktok from '../assets/images/Icons/icon-sosmed/tiktok-icon.svg';
import playstore from '../assets/images/Icons/icon-sosmed/playstore-icon.svg';
import { Footer2Component } from '../components/footer/footer2-component';
const PrivacyPolicy = () => {
  return (
    <>
      {/* <!DOCTYPE html> */}
      {/* <html lang="en"> */}
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="facebook-domain-verification"
          content="rf11ik7ron1gr3x0tb5fk6q63ehvik"
        />
        <meta
          name="description"
          content="Platform agensi properti digital modern yang memudahkan kamu dalam proses pencarian properti impian dengan memilih agen yang kamu inginkan"
        />
        <meta
          name="keywords"
          content="Agensi properti, cari properti, properti"
        />
        <meta name="author" content="PT Sepakat Menjala Berkat" />
        <meta name="robots" content="index, follow" />
        <title>Sepakat Menjala Berkat</title>
        <link rel="icon" href="./assets/images/favicon.png" />
      </head>
      {/* <body> */}
      {/* <!-- Jumbotron Section --> */}
      <div className={`${style.jumbotron} jumbotron jumbotron-fluid`}>
        <div className={`${style.container} container`}>
          <h1>Privacy Policy</h1>
        </div>
      </div>
      {/* <!-- End Jumbotron --> */}

      {/* <!-- Main Section --> */}
      <main>
        <div className={`${style.container} container`}>
          <span className={`${style.en} en`}>EN</span>
          <input type="checkbox" className={`${style.check} check`} />
          <span className={`${style.id} id`}>ID</span>
          <div
            className={`${style.content} ${style.contentEnglish} content contentEnglish mt-4`}
          >
            <div className="poin-1">
              <h1>Privacy Policy</h1>
              <p>
                Andalan Solusi Cemerlang built the Sepakat app as a Commercial
                app. This SERVICE is provided by Andalan Solusi Cemerlang and is
                intended for use as is. This page is used to inform visitors
                regarding our policies with the collection, use, and disclosure
                of Personal Information if anyone decided to use our Service. If
                you choose to use our Service, then you agree to the collection
                and use of information in relation to this policy. The Personal
                Information that we collect is used for providing and improving
                the Service. We will not use or share your information with
                anyone except as described in this Privacy Policy. The terms
                used in this Privacy Policy have the same meanings as in our
                Terms and Conditions, which are accessible at Sepakat unless
                otherwise defined in this Privacy Policy
              </p>
            </div>
            <div className="poin-2">
              <h1>Information Collection and Use</h1>
              <p>
                For a better experience, while using our Service, we may require
                you to provide us with certain personally identifiable
                information, including but not limited to Location. The
                information that we request will be retained by us and used as
                described in this privacy policy. The app does use third-party
                services that may collect information used to identify you. Link
                to the privacy policy of third-party service providers used by
                the app Google Play Services
              </p>
            </div>
            <div className="poin-3">
              <h1>Log Data</h1>
              <p>
                We want to inform you that whenever you use our Service, in a
                case of an error in the app we collect data and information
                (through third-party products) on your phone called Log Data.
                This Log Data may include information such as your device
                Internet Protocol (“IP”) address, device name, operating system
                version, the configuration of the app when utilizing our
                Service, the time and date of your use of the Service, and other
                statistics.
              </p>
            </div>
            <div className="poin-4">
              <h1>Cookies</h1>
              <p>
                Cookies are files with a small amount of data that are commonly
                used as anonymous unique identifiers. These are sent to your
                browser from the websites that you visit and are stored on your
                device's internal memory. This Service does not use these
                “cookies” explicitly. However, the app may use third-party code
                and libraries that use “cookies” to collect information and
                improve their services. You have the option to either accept or
                refuse these cookies and know when a cookie is being sent to
                your device. If you choose to refuse our cookies, you may not be
                able to use some portions of this Service.
              </p>
            </div>
            <div className="poin-5">
              <h1>Service Providers</h1>
              <p>
                We may employ third-party companies and individuals due to the
                following reasons:
              </p>
              <ul>
                <li>To facilitate our Service;</li>
                <li>To provide the Service on our behalf;</li>
                <li>To perform Service-related services; or</li>
                <li>To assist us in analyzing how our Services is used.</li>
              </ul>
              <p>
                We want to inform users of this Services that these third
                parties have access to their Personal Information. The reason is
                to perform the tasks assigned to them on our behalf. However,
                they are obligated not to disclose or use the information for
                any other purpose.
              </p>
            </div>
            <div className="poin-6">
              <h1>Security</h1>
              <p>
                We value your trust in providing us your Personal Information,
                thus we are striving to use commercially acceptable means of
                protecting it. But remember that no method of transmission over
                the internet, or method of electronic storage is 100% secure and
                reliable, and we cannot guarantee its absolute security.
              </p>
            </div>
            <div className="poin-7">
              <h1>Links to Other Sites</h1>
              <p>
                This Service may contain links to other sites. If you click on a
                third-party link, you will be directed to that site. Note that
                these external sites are not operated by us. Therefore, we
                strongly advise you to review the Privacy Policy of these
                websites. We have no control over and assume no responsibility
                for the content, privacy policies, or practices of any
                third-party sites or services.
              </p>
            </div>
            <div className="poin-8">
              <h1>Childern's Privacy</h1>
              <p>
                These Services do not address anyone under the age of 13. We do
                not knowingly collect personally identifiable information from
                children under 13 years of age. In the case we discover that a
                child under 13 has provided us with personal information, we
                immediately delete this from our servers. If you are a parent or
                guardian and you are aware that your child has provided us with
                personal information, please contact us so that we will be able
                to do the necessary actions.
              </p>
            </div>
            <div className="poin-9">
              <h1>Changes to This Privacy Policy</h1>
              <p>
                We may update our Privacy Policy from time to time. Thus, you
                are advised to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page. This policy is effective as of 2022-06-08
              </p>
            </div>
            <div className="poin-10">
              <h1>Contact Us</h1>
              <p>
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to contact us at
                Andalansolusicemerlang@gmail.com.
              </p>
            </div>
          </div>
          <div
            className={`${style.content} ${style.contentIndonesia}  content contentIndonesia`}
          >
            <div className="poin-1">
              <h1>Kebijakan dan privasi</h1>
              <p>
                Andalan Solusi Cemerlang membangun aplikasi Sepakat sebagai
                aplikasi Komersial. LAYANAN ini disediakan oleh Andalan Solusi
                Cemerlang dan dimaksudkan untuk digunakan apa adanya. Halaman
                ini digunakan untuk memberi tahu pengunjung mengenai kebijakan
                kami dengan pengumpulan, penggunaan, dan pengungkapan Informasi
                Pribadi jika ada yang memutuskan untuk menggunakan Layanan kami.
                Jika Anda memilih untuk menggunakan Layanan kami, maka Anda
                menyetujui pengumpulan dan penggunaan informasi sehubungan
                dengan kebijakan ini. Informasi Pribadi yang kami kumpulkan
                digunakan untuk menyediakan dan meningkatkan Layanan. Kami tidak
                akan menggunakan atau membagikan informasi Anda dengan siapa pun
                kecuali sebagaimana dijelaskan dalam Kebijakan Privasi ini.
                Istilah yang digunakan dalam Kebijakan Privasi ini memiliki arti
                yang sama seperti dalam Syarat dan Ketentuan kami, yang dapat
                diakses di Sepakat kecuali ditentukan lain dalam Kebijakan
                Privasi ini.
              </p>
            </div>
            <div className="poin-2">
              <h1>Pengumpulan dan Penggunaan Informasi</h1>
              <p>
                Untuk pengalaman yang lebih baik, saat menggunakan Layanan kami,
                kami mungkin meminta Anda untuk memberikan kami informasi
                pengenal pribadi tertentu, termasuk namun tidak terbatas pada
                Lokasi. Informasi yang kami minta akan disimpan oleh kami dan
                digunakan seperti yang dijelaskan dalam kebijakan privasi ini.
                Aplikasi ini menggunakan layanan pihak ketiga yang dapat
                mengumpulkan informasi yang digunakan untuk mengidentifikasi
                Anda. Tautan ke kebijakan privasi penyedia layanan pihak ketiga
                yang digunakan oleh aplikasi Layanan Google Play
              </p>
            </div>
            <div className="poin-3">
              <h1>Log Data</h1>
              <p>
                Kami ingin memberi tahu Anda bahwa setiap kali Anda menggunakan
                Layanan kami, jika terjadi kesalahan dalam aplikasi, kami
                mengumpulkan data dan informasi (melalui produk pihak ketiga) di
                ponsel Anda yang disebut Data Log. Data Log ini dapat mencakup
                informasi seperti alamat Protokol Internet (“IP”) perangkat
                Anda, nama perangkat, versi sistem operasi, konfigurasi aplikasi
                saat menggunakan Layanan kami, waktu dan tanggal penggunaan
                Layanan oleh Anda, dan statistik lainnya
              </p>
            </div>
            <div className="poin-4">
              <h1>Cookies</h1>
              <p>
                Cookie adalah file dengan sejumlah kecil data yang biasanya
                digunakan sebagai pengidentifikasi unik anonim. Ini dikirim ke
                browser Anda dari situs web yang Anda kunjungi dan disimpan di
                memori internal perangkat Anda. Layanan ini tidak menggunakan
                “cookies” ini secara eksplisit. Namun, aplikasi dapat
                menggunakan kode dan perpustakaan pihak ketiga yang menggunakan
                "cookies" untuk mengumpulkan informasi dan meningkatkan layanan
                mereka. Anda memiliki pilihan untuk menerima atau menolak cookie
                ini dan mengetahui kapan cookie dikirim ke perangkat Anda. Jika
                Anda memilih untuk menolak cookie kami, Anda mungkin tidak dapat
                menggunakan beberapa bagian dari Layanan ini.
              </p>
            </div>
            <div className="poin-5">
              <h1>Penyedia Jasa</h1>
              <p>
                Kami dapat memperkerjakan perusahaan dan individu pihak ketiga
                karena alasan berikut:
              </p>
              <ul>
                <li>Untuk memfasilitasi Layanan kami;</li>
                <li>Untuk menyediakan Layanan atas nama kami;</li>
                <li>Untuk melakukan layanan terkait Layanan; atau</li>
                <li>
                  Untuk membantu kami dalam menganalisis bagaimana Layanan kami
                  digunakan.
                </li>
              </ul>
              <p>
                Kami ingin memberi tahu pengguna Layanan ini bahwa pihak ketiga
                ini memiliki akses ke informasi Pribadi mereka. Alasannya adalah
                untuk melakukan tugas yang diberikan kepada mereka atas nama
                kita. Namun, mereka berkewajiban untuk tidak mengungkapkan atau
                menggunakan informasi tersebut untuk tujuan yang lain.
              </p>
            </div>
            <div className="poin-6">
              <h1>Keamanan</h1>
              <p>
                Kami menghargai kepercayaan Anda dalam memberikan Informasi
                Pribadi Anda kepada kami, oleh karena itu kami berusaha untuk
                menggunakan cara yang dapat diterima secara komersial untuk
                melindunginya. Tetapi ingat bahwa tidak ada metode transmisi
                melalui internet, atau metode penyimpanan elektronik yang 100%
                aman dan andal, dan kami tidak dapat menjamin keamanan
                mutlaknya.
              </p>
            </div>
            <div className="poin-7">
              <h1>Tautan ke Situs lain</h1>
              <p>
                Layanan ini mungkin berisi tautan ke situs lain. Jika Anda
                mengklik tautan pihak ketiga, Anda akan diarahkan ke situs itu.
                Perhatikan bahwa situs eksternal ini tidak dioperasikan oleh
                kami. Oleh karena itu, kami sangat menyarankan Anda untuk
                meninjau Kebijakan Privasi situs web ini. Kami tidak memiliki
                kendali atas dan tidak bertanggung jawab atas konten, kebijakan
                privasi, atau praktik situs atau layanan pihak ketiga mana pun.
              </p>
            </div>
            <div className="poin-8">
              <h1>Privasi Anak-Anak</h1>
              <p>
                Layanan ini tidak ditujukan kepada siapa pun yang berusia di
                bawah 13 tahun. Kami tidak dengan sengaja mengumpulkan informasi
                pengenal pribadi dari anak-anak di bawah 13 tahun. Jika kami
                menemukan bahwa seorang anak di bawah 13 tahun telah memberi
                kami informasi pribadi, kami segera menghapusnya dari server
                kami. Jika Anda adalah orang tua atau wali dan Anda mengetahui
                bahwa anak Anda telah memberikan informasi pribadi kepada kami,
                silakan hubungi kami sehingga kami dapat melakukan tindakan yang
                diperlukan.
              </p>
            </div>
            <div className="poin-9">
              <h1>Perubahan pada Kebijakan Privasi Ini</h1>
              <p>
                Kami dapat memperbarui Kebijakan Privasi kami dari waktu ke
                waktu. Oleh karena itu, Anda disarankan untuk meninjau halaman
                ini secara berkala untuk setiap perubahan. Kami akan memberi
                tahu Anda tentang perubahan apa pun dengan memposting Kebijakan
                Privasi baru di halaman ini. Kebijakan ini berlaku mulai 6
                Agustus 2022
              </p>
            </div>
            <div className="poin-10">
              <h1>Kontak Kami</h1>
              <p>
                Jika Anda memiliki pertanyaan atau saran tentang Kebijakan
                Privasi kami, jangan ragu untuk menghubungi kami di
                Andalansolusicemerlang@gmail.com.
              </p>
            </div>
          </div>
        </div>
      </main>
      {/* <!-- End Main --> */}

      <Footer2Component />
    </>
  );
};

export default PrivacyPolicy;
